import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonTab from '../email-setting/components/Button';
import { Icon } from '../email-setting/components/icon';
import StepWizard from 'react-step-wizard';

import Filter from './components/Filter';
import FilterPersonal from './components/FilterP';

import Tab1 from './components/Tab1';
import Tab2 from './components/Tab2';
import Tab3 from './components/Tab3';

export const TAB = {
    DATAFLOW: 'dataflow',
    ROPA: 'ropa',
    PERSONAL: 'personal',
};

export const TAB_STATE = {
    DATAFLOW: 0,
    ROPA: 1,
    PERSONAL: 2,
};

export default function DataInquiry() {
    const { t } = useTranslation();
    const [state, setState] = useState();
    const [activeStep, setActiveStep] = useState(0);

    const [statusId, setStatusId] = useState('');
    const [departmentId, setDepartmentId] = useState('');

    const setInstance = (SW) => {
        setState({
            ...state,
            SW,
        });
        setActiveStep(SW.state.activeStep);
    };

    return (
        <div>
            <div className="title ">{t('common.DataInquiry')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.DataInquiry')}
                </span>
            </div>
            <div className="flex items-center gap-4 my-4">
                <ButtonTab
                    key="dataflow"
                    title={t('Data Subject Type relate to Data Flow')}
                    icon={Icon.peple}
                    active={activeStep === TAB_STATE.DATAFLOW}
                    onClick={() => state?.SW?.goToStep(1)}
                />
                <ButtonTab
                    key="ropa"
                    title={t('Data Subject Type relate to RoPA')}
                    icon={Icon.peple}
                    active={activeStep === TAB_STATE.ROPA}
                    onClick={() => state?.SW?.goToStep(2)}
                />
                <ButtonTab
                    key="sensitive"
                    title={t('Personal-Sensitive Data relate to Activities')}
                    icon={Icon.hash}
                    active={activeStep === TAB_STATE.PERSONAL}
                    onClick={() => state?.SW?.goToStep(3)}
                />
            </div>

            <div className="grid grid-cols-7 gap-4">
                {activeStep === TAB_STATE.PERSONAL ? (
                    <FilterPersonal departmentId={departmentId} />
                ) : (
                    <Filter statusId={statusId} departmentId={departmentId} />
                )}
                <StepWizard
                    className="bg-white col-span-5 rounded-lg p-4 h-max"
                    isHashEnabled
                    instance={setInstance}
                    onStepChange={({ activeStep }) => {
                        setActiveStep(activeStep - 1);
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                >
                    <Tab1
                        setDepartmentId={setDepartmentId}
                        setStatusId={setStatusId}
                        hashKey={TAB.DATAFLOW}
                    />
                    <Tab2
                        setDepartmentId={setDepartmentId}
                        setStatusId={setStatusId}
                        hashKey={TAB.ROPA}
                    />
                    <Tab3
                        setDepartmentId={setDepartmentId}
                        hashKey={TAB.PERSONAL}
                    />
                </StepWizard>
            </div>
        </div>
    );
}
